"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = series;
function series(reducer, initial) {
  return function (iterable) {
    return iterable.reduce(function (chain, value, key) {
      return chain.then(function (results) {
        return reducer(results, value, key, iterable);
      });
    }, Promise.resolve(initial));
  };
}